/**
 * Logger Condizionale
 * In produzione, i log vengono disabilitati per migliorare le prestazioni
 * Solo errori e warning rimangono sempre visibili
 */

const isDevelopment = process.env.NODE_ENV === 'development';

export const logger = {
  /**
   * Log normale - solo in development
   */
  log: (...args) => {
    if (isDevelopment) {
      console.log(...args);
    }
  },

  /**
   * Info - solo in development
   */
  info: (...args) => {
    if (isDevelopment) {
      console.info(...args);
    }
  },

  /**
   * Debug - solo in development
   */
  debug: (...args) => {
    if (isDevelopment) {
      console.debug(...args);
    }
  },

  /**
   * Warning - sempre visibile
   */
  warn: (...args) => {
    console.warn(...args);
  },

  /**
   * Errore - sempre visibile
   */
  error: (...args) => {
    console.error(...args);
  },

  /**
   * Group - solo in development
   */
  group: (label) => {
    if (isDevelopment && console.group) {
      console.group(label);
    }
  },

  /**
   * GroupEnd - solo in development
   */
  groupEnd: () => {
    if (isDevelopment && console.groupEnd) {
      console.groupEnd();
    }
  },

  /**
   * Table - solo in development
   */
  table: (data) => {
    if (isDevelopment && console.table) {
      console.table(data);
    }
  },
};

export default logger;